import { marketingAdministratorRoles } from "../config/roles";
import { communicationFilters, communicationTypeOptions } from "./communicationFilters";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/email-communication";

/**
 * The email communications list. Every communication comes back in one request, so its
 * filters narrow what is already loaded.
 */
export const communicationsListDefinition: ListDefinition = {
  path: "/email-communications",
  entityName: "g4c_communication",
  recordRoute,
  title: "Email Communications",
  allowedRoles: marketingAdministratorRoles,
  data: "all-at-once",
  filters: [
    ...communicationFilters,
    {
      name: "g4c_campaignid",
      label: "Reporting Campaign",
      kind: "lookup",
      lookupEntity: "campaign",
      searchable: true,
    },
  ],
  filterByStatus: false,
  // Inactive is one of the Status filter's choices, so those records are read too.
  readInactive: true,
  alphabetPagination: true,
  allowAdd: true,
  allowStatusEdit: true,
  defaultSortKey: "g4c_startdate",
  defaultSortDir: "desc",
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "statuscode",
      label: "Status",
      width: 200,
      sortable: true,
      display: "component",
      componentKey: "communicationStatus",
    },
    {
      key: "g4c_communicationtype",
      label: "Type",
      width: 200,
      sortable: true,
      display: "picklist",
      options: communicationTypeOptions,
    },
    {
      key: "g4c_campaignid",
      label: "Reporting Campaign",
      width: 200,
      sortable: true,
      link: { to: "/reporting-campaign", idKey: "g4c_campaignid", newTab: "button" },
    },
    {
      key: "g4c_audienceid",
      label: "Audience",
      width: 200,
      sortable: true,
      link: { to: "/audience", idKey: "g4c_audienceid", newTab: "button" },
    },
    {
      key: "g4c_startdate",
      label: "Start Date",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "g4c_enddate",
      label: "End Date",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    { key: "g4c_sid", label: "SID", width: 100, sortable: true },
    {
      key: "g4c_usedynamiccontent",
      label: "Use Dynamic Content",
      width: 200,
      display: "yesno",
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
